export const Header = () => {
  return (
    <div className="w-full sticky-header py-2 font-light text-xs text-white bg-lime-600 z-10">
      <div className="container">
        <div className="marquee-wrapper overflow-hidden">
          <div className="animate-marquee-wrapper flex">
            <div className="animate-marquee whitespace-nowrap animate-marquee-1">
              Jakarta Open Trail Run (JOTR) Cianjur Series 2026 — Official Host of
              the Southeast Asian Trail Running Cup.
            </div>
            <div className="animate-marquee whitespace-nowrap animate-marquee-2 ml-96">
              Elite trail runners from across Southeast Asia compete on the
              challenging terrain of Mount Gede Pangrango National Park,
              Indonesia.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
